import { Breadcrumb } from "antd"
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

const BreadcumbComponent = () => {
  const [data, setData] = useState([])
  const breadcumbData = useSelector((state) => state.auth.breadcumb);

  const location = useLocation()
  useEffect(() => {
    setData(breadcumbData)
  }, [breadcumbData])

  if (location?.pathname.includes('login') || location?.pathname.includes('reset-password')) return null

  return (
    <div className="bg-primary-white px-6 py-4 mb-6">
      <Breadcrumb
        items={data}
      />
      <h3 className="text-4xl mt-2 font-medium">{breadcumbData[breadcumbData.length - 1]?.title}</h3>
    </div>
  )
}

export default BreadcumbComponent